import React, { useState } from "react";
import { useAuth } from "@/lib/auth";
import { PageTitle } from "@/components/shared/primitives";
import { Tabs } from "@/components/kit";
import DataSources from "@/components/settings/DataSources";
import Extension from "@/components/settings/Extension";
import FeatureMaps from "@/components/settings/FeatureMaps";
import TeamsPeople from "@/components/settings/TeamsPeople";
import Offices from "@/components/settings/Offices";
import RolesAccess from "@/components/settings/RolesAccess";
import Privacy from "@/components/settings/Privacy";

const TABS = [
  { id: "data", label: "Data sources", roles: ["admin", "it_admin"], el: DataSources },
  { id: "teams", label: "Teams and people", roles: ["admin"], el: TeamsPeople },
  { id: "roles", label: "Roles and access", roles: ["admin"], el: RolesAccess },
  { id: "privacy", label: "Privacy", roles: ["admin"], el: Privacy },
  { id: "feature_maps", label: "Feature maps", roles: ["admin"], el: FeatureMaps },
  { id: "offices", label: "Offices", roles: ["admin"], el: Offices },
  { id: "extension", label: "Extension", roles: ["admin", "it_admin"], el: Extension },
];

export default function Settings() {
  const { role } = useAuth();
  const tabs = TABS.filter((t) => t.roles.includes(role));
  const [active, setActive] = useState(tabs[0]?.id);
  const ActiveEl = tabs.find((t) => t.id === active)?.el || (() => null);

  return (
    <div>
      <PageTitle sub="Data sources, extension health, feature maps, people, roles and privacy." testid="settings-page">
        Settings
      </PageTitle>
      <div className="mb-6">
        <Tabs tabs={tabs.map((t) => ({ key: t.id, label: t.label }))} value={active} onChange={setActive} testid="settings-tabs" />
      </div>
      <div className="nb-fade" key={active}>
        <ActiveEl />
      </div>
    </div>
  );
}
